import React from 'react'
import { Loader2, RefreshCw, Home } from 'lucide-react'
import { Button, Card } from '../ui'

const RoomStateGate = ({
  isLoading = false,
  roomNotFound = false,
  roomCode = '',
  onRetry
}) => {
  if (!isLoading && !roomNotFound) {
    return null
  }

  if (isLoading) {
    return (
      <div
        className="participant-room-theme flex min-h-[100dvh] items-center justify-center px-4 text-[var(--room-text)]"
      >
        <Card
          className="room-elevated w-full max-w-md border p-6 text-center"
        >
          <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-primary-500/15 text-primary-500">
            <Loader2 className="h-5 w-5 animate-spin" />
          </div>
          <h1 className="text-lg font-semibold">Joining room</h1>
          <p className="mt-2 text-sm text-[var(--room-muted)]">
            Connecting to room <span className="font-semibold uppercase">{roomCode || '...'}</span>.
          </p>
        </Card>
      </div>
    )
  }

  return (
    <div
      className="participant-room-theme flex min-h-[100dvh] items-center justify-center px-4 text-[var(--room-text)]"
    >
      <Card
        className="room-elevated w-full max-w-md border p-6"
      >
        <h1 className="text-lg font-semibold">Room unavailable</h1>
        <p className="mt-2 text-sm text-[var(--room-muted)]">
          Room <span className="font-semibold uppercase">{roomCode || 'unknown'}</span> is invalid, expired, or no
          longer active.
        </p>
        <p className="mt-1 text-sm text-[var(--room-muted)]">
          Try reloading, or return home and join with a valid room code.
        </p>

        <div className="mt-5 flex flex-col gap-2 sm:flex-row">
          <Button
            type="button"
            className="room-focus-ring flex h-11 items-center justify-center gap-2 rounded-xl border border-[color:var(--room-primary)] bg-[color:rgba(46,168,255,0.22)] text-[var(--room-text)] hover:bg-[color:rgba(46,168,255,0.3)]"
            onClick={onRetry}
            aria-label="Retry room join"
          >
            <RefreshCw className="h-4 w-4" />
            Retry
          </Button>

          <a href="/" className="flex-1">
            <Button
              type="button"
              variant="secondary"
              className="room-focus-ring h-11 w-full rounded-xl border border-white/15 bg-white/5 text-[var(--room-muted)] hover:bg-white/10 hover:text-[var(--room-text)]"
              aria-label="Go back home"
            >
              <span className="inline-flex items-center gap-2">
                <Home className="h-4 w-4" />
                Back Home
              </span>
            </Button>
          </a>
        </div>
      </Card>
    </div>
  )
}

export default RoomStateGate
